import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { DepositAccountType } from '@/types/depositAccountType';

export type DepositAccountUpdateDataType = {
  name: string;
};

export const editDepositAccountApi = (
  depositAccountId: string,
  data: DepositAccountUpdateDataType
): Promise<ApiResponseType<DepositAccountType>> => {
  const uri = `/organization/deposit-accounts/${depositAccountId}/`;

  return authApiService.PATCH(uri, data);
};
